<template>
  <div class="education-form">
    <div class="service-from fieldset-form" v-if="objectInstance">
    <div class="row gx-1">
      <div class="col-sm-6">
        <div
          v-bind:class="{ 'form-group--invalid': errors.name }"
          class="service-from__form-group form-group fieldset-form__form-group">
          <input
            v-model="objectInstance.name"
            placeholder="Место учебы"
            type="text"
            class="form-group__input form-control service-from__form-control fieldset-form__form-control">
          <p class="form-group__error-message invalid-feedback" v-if="errors.name">{{ errors.name.join(', ') }}</p>
        </div>
      </div>
      <div class="col-sm-6">
        <div
          v-bind:class="{ 'form-group--invalid': errors.position }"
          class="service-from__form-group form-group fieldset-form__form-group">
          <input
            v-model="objectInstance.position"
            placeholder="Специальность"
            type="text"
            class="form-group__input form-control service-from__form-control fieldset-form__form-control">
          <p class="form-group__error-message invalid-feedback" v-if="errors.position">{{ errors.position.join(', ') }}</p>
        </div>
      </div>
    </div>
    <div class="service-from__actions fieldset-form__actions">
      <button
        @click="saveForm()"
        type="button"
        class="btn btn--inverse-primary service-from__save">Сохранить</button>
      <button
        @click="closeForm"
        type="button"
        class="btn btn--outline-variant service-from__cancel">Отмена</button>
    </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios'


export default {

  name: 'EducationForm',

  props: {
    objectItem: {
      type: Object,
      default: null
    },
    ancetId: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
      objectInstance: null,
      errors: {}
    }
  },

  mounted () {
    if (this.objectItem) {
      this.objectInstance = this.objectItem
    } else {
      this.objectInstance = {
        id: null,
        ancet: this.ancetId,
        name: null,
        position: null
      }
    }
  },

  methods: {
    closeForm () {
      this.$emit('close')
    },

    saveForm () {
      if (this.objectInstance.id) {
        axios.put(`/ancet/api/education/${this.objectInstance.id}/`, this.objectInstance)
          .then(response => {
            this.objectInstance = response.data
            this.errors = {}
            this.$emit('update', this.objectInstance)
          })
          .catch(error => {
            this.errors = error.response.data
          })
      } else {
        axios.post(`/ancet/api/education/create/`, this.objectInstance)
          .then(response => {
            this.objectInstance = response.data
            this.errors = {}
            this.$emit('create', this.objectInstance)
          })
          .catch(error => {
            this.errors = error.response.data
          })
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>